import duckLeft from "../media/duck-left.png";
import duckRight from "../media/duck-right.png";

import telegram from "../media/telegram-light.png";
import x from "../media/x-light.png";
import chart from "../media/chart.png";

function JoinFlock() {

    return (

        <section className="join-flock" id="community">

            <div className="container">

                <div className="row align-items-center">

                    {/* Left Duck */}

                    <div className="col-lg-2 d-none d-lg-block">

                        <div className="join-duck text-start">

                            <img
                                src={duckLeft}
                                alt=""
                                className="img-fluid"
                            />

                        </div>

                    </div>

                    {/* Center */}

                    <div className="col-lg-8">

                        <div className="join-content">

                            <h2>JOIN THE FLOCK.</h2>

                            <div className="join-buttons">

                                <a
                                    href="https://t.me/SIrTube"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="join-btn telegram-btn"
                                >

                                    <img src={telegram} alt="" />

                                    <span>TELEGRAM</span>

                                </a>

                                <a
                                    href="https://x.com/Sirtube_sol"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="join-btn x-btn"
                                >

                                    <img src={x} alt="" />

                                    <span>FOLLOW ON X</span>

                                </a>

                                <a
                                    href="https://dexscreener.com/solana/8hmz7mtbwi8whatnifsxtmmpqy3jj7z8ih3p1sxumu8g"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="join-btn chart-btn"
                                >

                                    <img src={chart} alt="" />

                                    <span>CHART</span>

                                </a>

                            </div>

                        </div>

                    </div>

                    {/* Right Duck */}

                    <div className="col-lg-2 d-none d-lg-block">

                        <div className="join-duck text-end">

                            <img
                                src={duckRight}
                                alt=""
                                className="img-fluid"
                            />

                        </div>

                    </div>

                </div>

            </div>

        </section>

    );

}

export default JoinFlock;